<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">
  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row">

      <div class="position-fixed-service border-right2 padding-right-0px">
        <div class="card">

          <div class="card-header wh-header header3 padding-right-32px bk-color-light">
            <div class="row margin-top10px margin-left-20px card-title-schedule-bb nav-link-hand" >
             
              <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                BGS SetUp</label>
                <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                    *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>
             
            </div>
            <div class="row margin-left-zero margin-top-10">
              Packages
            </div>



          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light">
            <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left16px">
              <div class="col-md-8 padding-right-0px padding-left-0px ">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              </div>
              <div class="col-md-2">
                <button type="button" (click)="AddCategory()" class="btn btn-new btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>
              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a  class="nav-link-hand education-navlink" tooltip="Edit">
                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                </a>

              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a class="nav-link-hand education-navlink" tooltip="Delete">
                  <span class="badge font-size-14">
                    <i class="far fa-trash-alt"></i>
                  </span>
                </a>
              </div>

            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-width-90 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                <div class="row border-bottom rowfor margin-left16px nav-link-hand" (click)="viewservice()" >
                  <div class="col-md-9 padding-right-0px padding-left-0px">

                    <a class="nav-link-hand margin-left-5px">Male Rhonie Examination</a>
                    </div>
                  <div class="col-md-1 padding-left-0px">
                    <a (click)="Editpackage()" class="nav-link-hand education-navlink">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                  </div>

                </div>
              </div>
            </div>

          </div>
          
        </div>
      </div>
      <div class="offset-md-2 col-md-10 padding-left-42px" *ngIf="ShowService">
        <div class="card">

        </div>
        <div class="row" >
          <div class="col-md-12 padding-left-0px">
            <div class="card">
              <div class="card-header wh-header border-bottom ">
                <div class="row">
                  <div class="col-md-2 padding-right-0px"><label class="label-size-2 font-color-secondary">Package Name</label></div>:
                  <div class="col-md-3 text-align-left"><label class="label-size-2">Male Rhonie Examination</label></div>
                  <!--<div class="col-md-6 padding-left-0px">
      <div class="row margin-left-zero margin-right-0px">

        <div class="col-md-3 margin-left-auto padding-right-0px">
          <button type="button" (click)="AddService()" class="btn btn-primary btn-sm margin-right-10px" hidden><i class="fas fa-plus nav-link-hand"></i></button>
          <button type="button" (click)="gotoservice()" class="btn  btn-detail btn-sm" hidden><i class="fas fa-list nav-link-hand"></i></button>
        </div>

        <div class="col-md-4 padding-right-0px padding-left-0px margin-right-8p">
          <div class="row">
            <div class="col-md-9 padding-right-0px">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange2($event)"></search-list>
            </div>
            <div class="col-md-1 padding-left-6px">
              <a *ngIf="pdata2"><div class="badge badge-search"><label class="margin-bottom-4px margin-top-4px"></label></div></a>
            </div>
          </div>

        </div>

      </div>
    </div>-->

                </div>
                <div class="row">
                  <div class="col-md-2 padding-right-0px"><label class="label-size-2 font-color-secondary">Mode</label></div>:
                  <div class="col-md-3 text-align-left"><label class="label-size-2">Print</label></div>
                  <!--<div class="col-md-2 padding-right-0px"><label class="label-size-2 font-color-secondary">Mode</label></div>:
  <div class="col-md-3 text-align-left">
    <div class="row">
      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">


          <div class="col-md-8 padding-left-0px">



          </div>



      </div>
    </div>
  </div>-->
                  <!--<div class="col-md-6 padding-left-0px">
    <div class="row margin-left-zero margin-right-0px">

      <div class="col-md-3 margin-left-auto padding-right-0px">
        <button type="button" (click)="AddService()" class="btn btn-primary btn-sm margin-right-10px" hidden><i class="fas fa-plus nav-link-hand"></i></button>
        <button type="button" (click)="gotoservice()" class="btn  btn-detail btn-sm" hidden><i class="fas fa-list nav-link-hand"></i></button>
      </div>

      <div class="col-md-4 padding-right-0px padding-left-0px margin-right-8p">
        <div class="row">
          <div class="col-md-9 padding-right-0px">
            <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange2($event)"></search-list>
          </div>
          <div class="col-md-1 padding-left-6px">
            <a *ngIf="pdata2"><div class="badge badge-search"><label class="margin-bottom-4px margin-top-4px"></label></div></a>
          </div>
        </div>

      </div>

    </div>
  </div>-->

                </div>
              </div>
              <div class="card-body ">
                <div class="row">
                  <div class="col-md-3">
                    <div class="card box-shadow-new">
                      <div class="card-header wh-header border-bottom padding-top-6px padding-bottom-6px">
                        <div class="row">
                          <div class="col-md-6">
                            Branch1
                          </div>
                          <div class="offset-md-4 col-md-2 padding-left-0px">
                            <a (click)="Editbranch()" class="nav-link-hand education-navlink">
                              <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                            </a>
                          </div>
                        </div>
                       
                      </div>
                      <div class="card-body padding-bottom-0px">
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service1</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service2</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service3</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service4</label>
                          </div>
                          
                        </div>
                       <div class="row height-39px background-secondary">
                         <div class="col-md-6 margin-top-6px font-size-20px color-primary padding-left-0px padding-right-0px margin-left-auto margin-right-auto text-align-center">
                          <label class="margin-bottom-0px">2740</label>
                         </div>
                       </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="card box-shadow-new">
                      <div class="card-header wh-header border-bottom padding-top-6px padding-bottom-6px">
                        <div class="row">
                          <div class="col-md-6">
                            Branch2
                          </div>
                          <div class="offset-md-4 col-md-2 padding-left-0px">
                            <a (click)="Editbranch()" class="nav-link-hand education-navlink">
                              <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="card-body padding-bottom-0px">
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service1</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service2</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service3</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service4</label>
                          </div>

                        </div>
                        <div class="row height-39px background-secondary">
                          <div class="col-md-6 margin-top-6px font-size-20px color-primary padding-left-0px padding-right-0px margin-left-auto margin-right-auto text-align-center">
                            <label class="margin-bottom-0px">2740</label>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="card box-shadow-new">
                      <div class="card-header wh-header border-bottom padding-top-6px padding-bottom-6px">
                        <div class="row">
                          <div class="col-md-6">
                            Branch3
                          </div>
                          <div class="offset-md-4 col-md-2 padding-left-0px">
                            <a (click)="Editbranch()" class="nav-link-hand education-navlink">
                              <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="card-body padding-bottom-0px">
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service1</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service2</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service3</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service4</label>
                          </div>

                        </div>
                        <div class="row height-39px background-secondary">
                          <div class="col-md-6 margin-top-6px font-size-20px color-primary padding-left-0px padding-right-0px margin-left-auto margin-right-auto text-align-center">
                            <label class="margin-bottom-0px">2740</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="card box-shadow-new">
                      <div class="card-header wh-header border-bottom padding-top-6px padding-bottom-6px">
                        <div class="row">
                          <div class="col-md-6">
                            Branch4
                          </div>
                          <div class="offset-md-4 col-md-2 padding-left-0px">
                            <a (click)="Editbranch()" class="nav-link-hand education-navlink">
                              <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                            </a>
                          </div>
                        </div>
                        
                      </div>
                      <div class="card-body padding-bottom-0px">
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service1</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service2</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service3</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <label>Service4</label>
                          </div>

                        </div>
                        <div class="row height-39px background-secondary">
                          <div class="col-md-6 margin-top-6px font-size-20px color-primary padding-left-0px padding-right-0px margin-left-auto margin-right-auto text-align-center">
                            <label class="margin-bottom-0px">2740</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     
   

      <!--<div class="row" *ngIf="SelectedService">

  TESTING  {{SelectedService.Code}}
  </div>-->



    </div>
      </div>

    </div>


